import { render } from "./WeeklyStatus.vue?vue&type=template&id=71055b99&scoped=true"
import script from "./WeeklyStatus.vue?vue&type=script&lang=js"
export * from "./WeeklyStatus.vue?vue&type=script&lang=js"

import "./WeeklyStatus.vue?vue&type=style&index=0&id=71055b99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71055b99"]])

export default __exports__